import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "./../commonBaseApiSlice";

export const customFieldsApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomFieldsMetadata: builder.mutation({
      query: () => ({
        url: `/customfieldmetadata/get`,
        method: "GET",
      }),
    }),
    getCustomFieldsMetadataById: builder.mutation({
      query: (data) => ({
        url: `/customfieldmetadata/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createCustomFieldsMetadata: builder.mutation({
      query: (data) => ({
        url: "/customfieldmetadata/create",
        method: "POST",
        body: data,
      }),
    }),
    editCustomFieldsMetadata: builder.mutation({
      query: (data) => ({
        url: "/customfieldmetadata/edit",
        method: "PUT",
        body: data,
      }),
    }),
    deleteCustomFieldsMetadata: builder.mutation({
      query: (data) => ({
        url: `/customfieldmetadata/softdelete?${getFilters(data)}`,
        method: "PUT",
      }),
    }),
    duplicateCustomFieldsMetadata: builder.mutation({
      query: (data) => ({
        url: `/customfieldmetadata/duplicate`,
        method: "POST",
        body: data,
      }),
    }),
    getAllCustomFieldsValues: builder.mutation({
      query: () => ({
        url: `/customfieldvalues/get`,
        method: "GET",
      }),
    }),
    getCustomFieldsValuesById: builder.mutation({
      query: (data) => ({
        url: `/customfieldvalues/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getCustomFieldsControlType: builder.mutation({
      query: () => ({
        url: `/controltype/get`,
        method: "GET",
      }),
    }),
    getCustomFieldsDataType: builder.mutation({
      query: () => ({
        url: `/datatype/get`,
        method: "GET",
      }),
    }),
    getCustomFieldsModule: builder.mutation({
      query: () => ({
        url: `customfieldmodules/get`,
        method: "GET",
      }),
    }),
  }),
});


export const {
    useGetCustomFieldsMetadataMutation,
    useGetCustomFieldsMetadataByIdMutation,
    useGetAllCustomFieldsValuesMutation,
    useGetCustomFieldsValuesByIdMutation,
    useGetCustomFieldsControlTypeMutation,
    useGetCustomFieldsDataTypeMutation,
    useGetCustomFieldsModuleMutation,
    useCreateCustomFieldsMetadataMutation,
    useEditCustomFieldsMetadataMutation,
    useDeleteCustomFieldsMetadataMutation,
    useDuplicateCustomFieldsMetadataMutation,
} = customFieldsApiSlice;